import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { DatePipe } from '@angular/common';
import { TblCommunicationSetup } from 'src/app/shared/models/communicationsetup';
import { CommunicationSetupService } from 'src/app/shared/services/communicationsetup.service';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditCommunicationSetupDialogComponent } from './edit-communication-setup-dialog.component';
import { PagerService } from 'src/app/shared/pagination';


@Component({
  selector: 'app-Campaign',
  templateUrl: './communication-setup.component.html',
  styleUrls: ['./communication-setup.component.css']
})
export class CommunicationSetupComponent implements OnInit {
  model: TblCommunicationSetup;
  members: Observable<TblCommunicationSetup[]>;
  allItems: TblCommunicationSetup[] = [];
  pagedItems: TblCommunicationSetup[] = [];
  pager: any = {};
  userType: string;
  constructor(private _communicationsetupervice : CommunicationSetupService,
    private dialog: MatDialog,
    private localStorage:LocalStorageService,
    private spinnerService: AppComponent ,private notifyService : NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblCommunicationSetup();
    this.getAllData();
  }
  getAllData(){
    this.members= this._communicationsetupervice.getAllCommunicationSetup();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  openAddDialog() {
    const model = new TblCommunicationSetup();
    const dialogRef = this.dialog.open(EditCommunicationSetupDialogComponent, {
      width: '500px',
      data: { title: 'New Communication Setup', model: model, isEditing: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.create_edit_after_dialog(false);
      }
    });
  }

  openEditDialog(id: any) {
    this._communicationsetupervice.getCommunicationSetupById(id).subscribe(resp => {
      const dialogRef = this.dialog.open(EditCommunicationSetupDialogComponent, {
        width: '500px',
        data: { title: 'Edit Communication Setup', model: resp, isEditing: true }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.model = result.model;
          this.create_edit_after_dialog(true);
        }
      });
    });
  }


  //Editing Data
  validateForm():boolean{
    
    if(!this.model.communicationName){
      this.notifyService.showError("Communication Setup Name can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }

  create_edit_after_dialog(isEditing: boolean){
    if(!this.validateForm()){
      return;
    }
    this._communicationsetupervice.saveAndUpdateCommunicationSetup(this.model).subscribe(resp=>{
      if(resp.refNo>0){
        this.notifyService.showSuccess(isEditing ? "Updated Successfully!" : "Saved Successfully!", "Success");
        this.getAllData()
      }
      else{
        this.notifyService.showError(resp.message, "Error")
      }
    },(err) => {
      this.notifyService.showError(err, "Error")
    });
  }
  close_clicked()
  {
    this.getAllData();
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
